<!-- 统计 -->
<template>
    <div>
      <div class="course_Statistics">
        <!-- 时间筛选 -->
        <el-row class="mb20 stat_filter">
          <label>时间筛选：</label>
            <el-date-picker
              v-model="value1"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          <el-button type="primary" icon="el-icon-search" @click="getInfo()">搜索</el-button>
          <span class="stat_filter_tip">时间筛选只影响下方基础概况与资源统计；班级活跃度固定近 30 天 / 近 14 天</span>
        </el-row>

        <!-- 学情概览：数据全部来自 statisticalAnalysis/detail.do 的 classActivity 节点 -->
        <div class="stat_section mb20">
          <p class="stat_sec_title">
            <i class="el-icon-data-line"></i> 学情概览
            <span class="stat_sec_sub">数据来源：统计分析详情接口 classActivity（固定近 30 天 / 近 14 天，不受上方时间筛选影响）</span>
            <el-tag
              v-if="selectedClass"
              type="info"
              size="mini"
              closable
              class="stat_filter_tag"
              @close="clearClassFilter"
            >{{selectedClass.className}} · {{selectedClass.studentNum}} 人 · 人均 {{fmtHours(selectedClass.avgOnlineHours)}} 小时</el-tag>
          </p>
          <!-- 顶部指标卡 -->
          <div class="kpi_cards">
            <div class="kpi_card kpi_blue">
              <span class="kpi_icon"><i class="el-icon-user"></i></span>
              <div class="kpi_body">
                <span class="kpi_label">学生总数</span>
                <span class="kpi_num">{{kpi.totalStudentNum}}<em class="kpi_unit">人</em></span>
                <span class="kpi_sub">覆盖 {{onlineHoursList.length}} 个班级</span>
              </div>
            </div>
            <div class="kpi_card kpi_purple">
              <span class="kpi_icon"><i class="el-icon-time"></i></span>
              <div class="kpi_body">
                <span class="kpi_label">人均在线时长（近30天）</span>
                <span class="kpi_num">{{kpi.avgOnlineHours}}<em class="kpi_unit">小时</em></span>
                <span class="kpi_sub">合计 {{kpi.totalOnlineHours}} 小时</span>
              </div>
            </div>
            <div class="kpi_card kpi_green">
              <span class="kpi_icon"><i class="el-icon-connection"></i></span>
              <div class="kpi_body">
                <span class="kpi_label">近7天活跃率</span>
                <span class="kpi_num">{{kpi.activeRate}}<em class="kpi_unit">%</em></span>
                <span class="kpi_sub">{{kpi.activeNum}} 人最近 7 天有登录</span>
              </div>
            </div>
            <div class="kpi_card kpi_orange">
              <span class="kpi_icon"><i class="el-icon-warning-outline"></i></span>
              <div class="kpi_body">
                <span class="kpi_label">需关注学生</span>
                <span class="kpi_num">{{kpi.riskNum}}<em class="kpi_unit">人</em></span>
                <span class="kpi_sub">沉默 {{kpi.silentNum}} · 流失 {{kpi.lostNum}}</span>
              </div>
            </div>
          </div>
          <!-- 图表区 -->
          <div class="stat_charts">
            <div class="chart_card">
              <p class="chart_title">各班级人均在线时长<span class="chart_note">单位：小时 · 点击柱形查看班级</span></p>
              <div id="stat_chart_bar" class="chart_box"></div>
            </div>
            <div class="chart_card">
              <p class="chart_title">学习活跃度分布<span class="chart_note">全课程 · 按最近登录分档</span></p>
              <div id="stat_chart_pie" class="chart_box"></div>
            </div>
            <div class="chart_card">
              <p class="chart_title">近14天每日活跃人数<span class="chart_note">全课程 · 当日去重登录学生</span></p>
              <div id="stat_chart_line" class="chart_box"></div>
            </div>
          </div>
          <p v-if="statLoading" class="stat_empty"><i class="el-icon-loading"></i> 学情数据加载中…</p>
          <p v-else-if="activityEmpty" class="stat_empty">接口未返回班级活跃度数据（classActivity），请确认后端已上线该版本</p>
        </div>

        <!-- 基础概况 -->
        <div class="stat_section mb20">
          <p class="stat_sec_title"><i class="el-icon-data-board"></i> 基础概况</p>
          <div class="base_cards">
            <div class="base_card">
              <span class="bc_label">班级数</span>
              <span class="bc_num">{{info.classNum || 0}}<em class="bc_unit">个</em></span>
            </div>
            <div class="base_card">
              <span class="bc_label">学生人数</span>
              <span class="bc_num">{{info.studentNum || 0}}<em class="bc_unit">人</em></span>
            </div>
            <div class="base_card base_card_pass">
              <span class="bc_label">学生通过率</span>
              <span class="bc_num" style="color: #67C23A;">{{info.passRate || 0}}<em class="bc_unit">%</em></span>
              <span class="bc_sub">{{info.studentPassNum || 0}} / {{info.studentNum || 0}} 人通过</span>
              <el-progress :text-inside="true" :stroke-width="14" color="#67C23A" :percentage="info.passRate || 0"></el-progress>
            </div>
          </div>
        </div>

        <!-- 课程资源学习情况 -->
        <div class="stat_section">
          <p class="stat_sec_title"><i class="el-icon-notebook-2"></i> 课程资源学习情况</p>
          <table class="kczy">
            <tr>
              <td>授课视频</td>
              <td>总数量（个）</td>
              <td>{{info.teachingVideoNum}}</td>
            </tr>
            <tr>
              <td>非视频资源</td>
              <td>总数量（个）</td>
              <td>{{info.nonVideoResourcesNum}}</td>
            </tr>
            <tr>
              <td>课程公告</td>
              <td>总数量（次）</td>
              <td>{{info.noticeNum}}</td>
            </tr>
            <tr>
              <td rowspan="2">签到</td>
              <td>数量（次）</td>
              <td>{{info.signInNum}}</td>
            </tr>
            <tr>
              <td>到课率（%）</td>
              <td>{{info.signInRate}}%</td>
            </tr>
            <tr>
              <td rowspan="3">章节练习</td>
              <td>总章节数（章）</td>
              <td>{{info.chapterNum}}</td>
            </tr>
            <tr>
              <td>习题总数（道）</td>
              <td>{{info.chapterTotal}}</td>
            </tr>
            <tr>
              <td>参与人数（人）</td>
              <td>{{info.chapterPeople}}</td>
            </tr>
            <tr>
              <td rowspan="3">课程实操</td>
              <td>总项目数（个）</td>
              <td>{{info.handsOnNum}}</td>
            </tr>
            <tr>
              <td>实操任务总数（个）</td>
              <td>{{info.handsOnTotal}}</td>
            </tr>
            <tr>
              <td>参与人数（人）</td>
              <td>{{info.handsOnPeople}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
</template>
<script>
import * as echarts from "echarts";

export default {
  name: 'Statistics',
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  data() {
    return {
      value1:"",
      info:{}, //statisticalAnalysis/detail.do 原始返回（含 classActivity）
      statLoading:false, //学情数据加载中
      selectedClass:null, //柱形图点选的班级（仅高亮，不改变分布/趋势口径）
      charts:{bar:null, pie:null, line:null} //echarts 实例，销毁时统一释放
    }
  },
  watch: {
    //点选班级只影响柱形图高亮，分布图与趋势图为全课程口径不重绘
    selectedClass() {
      this.$nextTick(() => {
        this.renderBar();
      });
    }
  },
  beforeDestroy() {
    this.destroyCharts();
    if (this._statResize) {
      window.removeEventListener("resize", this._statResize);
    }
  },
  computed: {
    //接口新增节点：{classOnlineHours, activityDistribution, dailyActiveList}
    classActivity() {
      return this.info.classActivity || {};
    },
    //① 班级人均在线时长：classId / className / studentNum / avgOnlineHours（后端已降序，这里再排一次防乱序）
    onlineHoursList() {
      let list = this.classActivity.classOnlineHours;
      if (!Array.isArray(list)) return [];
      return list.slice().sort((a, b) => {
        return Number(b.avgOnlineHours || 0) - Number(a.avgOnlineHours || 0);
      });
    },
    //② 学习活跃度分布：四个数相加恒等于 totalStudentNum
    dist() {
      let d = this.classActivity.activityDistribution || {};
      return {
        totalStudentNum: Number(d.totalStudentNum) || 0,
        activeNum: Number(d.activeNum) || 0,
        generalNum: Number(d.generalNum) || 0,
        silentNum: Number(d.silentNum) || 0,
        lostNum: Number(d.lostNum) || 0
      };
    },
    //③ 近14天每日活跃人数：后端已补齐 14 条并升序，直接 map
    dailyList() {
      let list = this.classActivity.dailyActiveList;
      return Array.isArray(list) ? list : [];
    },
    //三项全空说明后端未返回该节点
    activityEmpty() {
      return !this.onlineHoursList.length && !this.dailyList.length && !this.dist.totalStudentNum;
    },
    //顶部四张指标卡：全部由 classActivity 真实汇总，无数据时为 0
    kpi() {
      let d = this.dist;
      let total = d.totalStudentNum;
      let sumHours = 0;
      this.onlineHoursList.forEach((item) => { //班级人均 × 班级人数 ≈ 班级总时长
        sumHours += Number(item.avgOnlineHours || 0) * Number(item.studentNum || 0);
      });
      let totalStudents = 0;
      this.onlineHoursList.forEach((item) => { totalStudents += Number(item.studentNum || 0); });
      let base = total > 0 ? total : totalStudents; //分布节点缺失时退回班级人数合计
      return {
        totalStudentNum: base,
        totalOnlineHours: this.fmtNum(sumHours),
        avgOnlineHours: this.fmtNum(base > 0 ? sumHours / base : 0),
        activeNum: d.activeNum,
        activeRate: this.fmtNum(total > 0 ? (d.activeNum / total) * 100 : 0),
        silentNum: d.silentNum,
        lostNum: d.lostNum,
        riskNum: d.silentNum + d.lostNum
      };
    },
    //环形图四段：活跃绿 / 一般蓝 / 沉默黄 / 流失红
    pieData() {
      let d = this.dist;
      return [
        {name: "活跃", value: d.activeNum, color: "#67C23A", desc: "7 天内有登录"},
        {name: "一般", value: d.generalNum, color: "#2789e2", desc: "8-15 天内有登录"},
        {name: "沉默", value: d.silentNum, color: "#E6A23C", desc: "16-30 天内有登录"},
        {name: "流失", value: d.lostNum, color: "#F56C6C", desc: "近 30 天无登录"}
      ];
    }
  },
  created() {
    this.getInfo();
  },
  mounted() {
    //窗口尺寸变化时重绘（含首次进入容器宽度为 0 的场景）
    this._statResize = () => {
      ["bar", "pie", "line"].forEach((k) => {
        if (this.charts[k]) {
          try { this.charts[k].resize(); } catch (e) {}
        }
      });
      if (!this.charts.bar || !this.charts.pie || !this.charts.line) this.renderCharts();
    };
    window.addEventListener("resize", this._statResize);
  },
  methods: {
    /* ==================== 学情辅助计算 ==================== */
    fmtHours(v) { //小时数保留 1 位小数（与后端返回口径一致）
      let n = Number(v);
      if (isNaN(n)) n = 0;
      return n.toFixed(1);
    },
    toggleClass(cls) { //柱形图点选班级：再次点击同一个取消
      if (!cls) return;
      if (this.selectedClass && this.selectedClass.classId === cls.classId) this.selectedClass = null;
      else this.selectedClass = cls;
    },
    clearClassFilter() {
      this.selectedClass = null;
    },
    /* ==================== 图表渲染 ==================== */
    destroyCharts() { //释放 echarts 实例，避免切换页面内存泄漏
      ["bar", "pie", "line"].forEach((k) => {
        if (this.charts[k]) {
          try { this.charts[k].dispose(); } catch (e) {}
          this.charts[k] = null;
        }
      });
    },
    initChart(id, key) { //取容器；已初始化且容器未变则直接复用，避免每次点选都重建导致闪烁
      let el = document.getElementById(id);
      if (!el) return null;
      let inst = this.charts[key];
      if (inst && !inst.isDisposed() && inst.getDom() === el) {
        if (el.offsetWidth <= 0) return null; //容器不可见，交给下次重试
        return inst;
      }
      if (inst) {
        try { inst.dispose(); } catch (e) {}
        this.charts[key] = null;
      }
      if (el.offsetWidth <= 0) return null; //容器不可见，交给下次重试
      this.charts[key] = echarts.init(el);
      return this.charts[key];
    },
    renderCharts() {
      this.renderBar();
      this.renderPie();
      this.renderLine();
    },
    renderBar() { //① 各班级人均在线时长（点击柱子查看班级）
      let chart = this.initChart("stat_chart_bar", "bar");
      if (!chart) return;
      let list = this.onlineHoursList;
      let selId = this.selectedClass ? this.selectedClass.classId : null;
      chart.setOption({
        grid: {left: 8, right: 16, top: 24, bottom: 8, containLabel: true},
        tooltip: {
          trigger: "axis",
          axisPointer: {type: "shadow"},
          formatter: (params) => {
            let p = params[0] || {};
            let hit = list[p.dataIndex] || {};
            return (hit.className || p.name) + "<br/>人均在线 " + this.fmtHours(p.value) + " 小时"
              + "<br/>班级人数 " + (hit.studentNum || 0) + " 人";
          }
        },
        xAxis: {
          type: "category",
          data: list.map((i) => i.className),
          axisLabel: {
            color: "#909399",
            fontSize: 12,
            interval: 0,
            lineHeight: 16,
            rotate: list.length > 4 ? 20 : 0,
            formatter: (name) => { //柱子下方带班级人数
              let hit = list.find((i) => i.className === name);
              return hit ? name + "\n" + (hit.studentNum || 0) + " 人" : name;
            }
          },
          axisLine: {lineStyle: {color: "#DCDFE6"}},
          axisTick: {show: false}
        },
        yAxis: {
          type: "value",
          name: "小时",
          nameTextStyle: {color: "#909399", fontSize: 12},
          axisLabel: {color: "#909399", fontSize: 12},
          splitLine: {lineStyle: {color: "#EBEEF5"}}
        },
        series: [{
          type: "bar",
          data: list.map((i) => Number(i.avgOnlineHours || 0)),
          barMaxWidth: 36,
          label: {
            show: true,
            position: "top",
            color: "#606266",
            fontSize: 12,
            formatter: (p) => this.fmtHours(p.value)
          },
          itemStyle: {
            borderRadius: [4, 4, 0, 0],
            color: (p) => {
              if (!selId) return "#2789e2";
              let item = list[p.dataIndex] || {};
              return item.classId === selId ? "#2789e2" : "#C0C4CC"; //未选中的班级置灰
            }
          }
        }]
      }, true); //notMerge：刷新时全量替换，避免旧班级残留
      if (!chart.__statBarBound) { //只绑一次；取数走在线数据源，避免闭包拿到旧数组
        chart.__statBarBound = true;
        chart.on("click", (params) => {
          if (!params || params.dataIndex === undefined) return;
          let cur = this.onlineHoursList;
          this.toggleClass(cur[params.dataIndex]);
        });
      }
    },
    renderPie() { //② 学习活跃度分布（环形，中心为当前学生数）
      let chart = this.initChart("stat_chart_pie", "pie");
      if (!chart) return;
      let buckets = this.pieData;
      let data = buckets.map((b) => {
        return {name: b.name, value: b.value, itemStyle: {color: b.color}};
      });
      chart.setOption({
        tooltip: {
          trigger: "item",
          formatter: (p) => {
            let hit = buckets.find((b) => b.name === p.name) || {};
            return p.name + "：" + p.value + " 人（" + p.percent + "%）" + (hit.desc ? "<br/>" + hit.desc : "");
          }
        },
        legend: {
          orient: "vertical",
          right: 4,
          top: "middle",
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 12,
          textStyle: {color: "#606266", fontSize: 12, lineHeight: 16},
          formatter: (name) => {
            let hit = buckets.find((b) => b.name === name) || {};
            return name + "  " + (hit.value || 0) + " 人\n" + (hit.desc || "");
          }
        },
        title: {
          text: String(this.kpi.totalStudentNum),
          subtext: "当前学生数",
          left: "32%",
          top: "40%",
          textAlign: "center",
          textStyle: {color: "#303133", fontSize: 22, fontWeight: "bold"},
          subtextStyle: {color: "#909399", fontSize: 12}
        },
        series: [{
          type: "pie",
          radius: ["46%", "68%"],
          center: ["32%", "52%"],
          avoidLabelOverlap: true,
          label: {show: false},
          labelLine: {show: false},
          data: data
        }]
      }, true);
    },
    renderLine() { //③ 近14天每日活跃人数（后端已补 0，不用自己补点）
      let chart = this.initChart("stat_chart_line", "line");
      if (!chart) return;
      let list = this.dailyList;
      let labelOf = (date) => { //yyyy-MM-dd → M/d
        let s = String(date || "");
        let parts = s.split("-");
        if (parts.length < 3) return s;
        return Number(parts[1]) + "/" + Number(parts[2]);
      };
      chart.setOption({
        grid: {left: 8, right: 16, top: 24, bottom: 8, containLabel: true},
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            let p = params[0] || {};
            let hit = list[p.dataIndex] || {};
            return (hit.date || p.name) + "<br/>当日活跃 " + p.value + " 人";
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: list.map((i) => labelOf(i.date)),
          axisLabel: {color: "#909399", fontSize: 12, interval: 1},
          axisLine: {lineStyle: {color: "#DCDFE6"}},
          axisTick: {show: false}
        },
        yAxis: {
          type: "value",
          minInterval: 1,
          name: "人",
          nameTextStyle: {color: "#909399", fontSize: 12},
          axisLabel: {color: "#909399", fontSize: 12},
          splitLine: {lineStyle: {color: "#EBEEF5"}}
        },
        series: [{
          type: "line",
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          data: list.map((i) => Number(i.activeNum) || 0),
          itemStyle: {color: "#2789e2"},
          lineStyle: {width: 2, color: "#2789e2"},
          areaStyle: {color: "rgba(39,137,226,0.15)"}
        }]
      }, true);
    },
    fmtNum(n) { //保留两位小数展示
      let v = Number(n);
      if (isNaN(v)) v = 0;
      return Math.round(v * 100) / 100;
    },
    getInfo(){
      let param = {teacherOpenCourseId:this.courseId}
       if(!this.$isEmpty(this.value1)){
        param.stime = this.value1[0];
        param.etime = this.value1[1];
      }
      this.statLoading = true;
      this.$get("/api/statisticalAnalysis/detail.do",param).then((ret) =>{
        if(ret.code == 0){
          let data = ret.data || {};
          if(!this.$isEmpty(data.passRate)){
            data.passRate = Number(String(data.passRate).replace("%",""));
          }
          this.info = data; //含 classActivity 节点，三张图数据一次返回
          this.selectedClass = null; //数据刷新后清空柱形图点选
          this.statLoading = false;
          this.drawChartsWhenReady();
        }else{
          this.statLoading = false;
          this.$message({message: ret.msg,type: 'error'});
        }
      }).catch(() => {
        this.statLoading = false;
      });
    },
    drawChartsWhenReady(){ //容器在 tab 未激活时宽度为 0，echarts 初始化会失败，延迟重试一次
      this.$nextTick(() => {
        this.renderCharts();
        setTimeout(() => {
          if (!this.charts.bar || !this.charts.pie || !this.charts.line) this.renderCharts();
        }, 400);
      });
    }
  }
};
</script>
<style  lang="less">
  .course_Statistics{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .content_block{
      background-color: #ffffff;
    }
    //筛选区：白底卡片，与内容区拉开层次
    .stat_filter{
      padding: 14px 16px;
      background-color: #ffffff;
      border: 1px solid #EBEEF5;
      border-radius: 4px;
      label{
        font-size: 14px;
        color: #606266;
      }
      //时间筛选口径提示：灰色小字，避免老师误以为三张图会跟着变
      .stat_filter_tip{
        margin-left: 12px;
        font-size: 12px;
        color: #909399;
      }
    }
    //分区标题：图标 + 主标题 + 灰色副标题，统一文字层级
    .stat_sec_title{
      margin: 0 0 12px;
      padding-left: 8px;
      border-left: 3px solid #2789e2;
      font-size: 15px;
      font-weight: bold;
      color: #303133;
      line-height: 20px;
      i{
        color: #2789e2;
        margin-right: 4px;
      }
      .stat_sec_sub{
        margin-left: 8px;
        font-size: 12px;
        font-weight: normal;
        color: #909399;
      }
    }
    //分区容器：白底卡片统一间距
    .stat_section{
      padding: 16px;
      background-color: #ffffff;
      border: 1px solid #EBEEF5;
      border-radius: 4px;
    }
    //筛选中的班级标签
    .stat_filter_tag{
      margin-left: 8px;
      vertical-align: middle;
    }
    //学情空态
    .stat_empty{
      margin: 12px 0 0;
      font-size: 13px;
      color: #909399;
      text-align: center;
    }
    //顶部指标卡：4 张横排，左侧彩色图标 + 右侧数值
    .kpi_cards{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -7px 16px;
      .kpi_card{
        display: flex;
        align-items: center;
        flex: 1;
        min-width: 210px;
        margin: 0 7px;
        padding: 14px 16px;
        background-color: #ffffff;
        border: 1px solid #EBEEF5;
        border-radius: 4px;
        .kpi_icon{
          display: flex;
          align-items: center;
          justify-content: center;
          width: 44px;
          height: 44px;
          margin-right: 12px;
          border-radius: 4px;
          flex-shrink: 0;
          i{
            font-size: 22px;
            color: #ffffff;
          }
        }
        .kpi_body{
          min-width: 0;
          .kpi_label{
            display: block;
            font-size: 13px;
            color: #909399;
            line-height: 18px;
          }
          .kpi_num{
            display: block;
            margin: 2px 0;
            font-size: 24px;
            font-weight: bold;
            color: #303133;
            line-height: 30px;
            .kpi_unit{
              margin-left: 4px;
              font-size: 12px;
              font-style: normal;
              font-weight: normal;
              color: #909399;
            }
          }
          .kpi_sub{
            display: block;
            font-size: 12px;
            color: #909399;
            line-height: 16px;
          }
        }
      }
      .kpi_blue .kpi_icon{background-color: #2789e2;}
      .kpi_purple .kpi_icon{background-color: #8A63E8;}
      .kpi_green .kpi_icon{background-color: #67C23A;}
      .kpi_orange .kpi_icon{background-color: #E6A23C;}
    }
    //图表区：3 张卡横排
    .stat_charts{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -7px;
      .chart_card{
        flex: 1;
        min-width: 300px;
        margin: 0 7px;
        padding: 12px;
        border: 1px solid #EBEEF5;
        border-radius: 4px;
        .chart_title{
          display: flex;
          align-items: baseline;
          justify-content: space-between;
          margin: 0 0 6px;
          font-size: 14px;
          font-weight: bold;
          color: #303133;
          line-height: 20px;
          .chart_note{
            font-size: 12px;
            font-weight: normal;
            color: #909399;
          }
        }
        .chart_box{
          width: 100%;
          height: 260px;
        }
      }
    }
    //基础概况：3 张卡，通过率卡内嵌进度条
    .base_cards{
      display: flex;
      flex-wrap: wrap;
      .base_card{
        flex: 1;
        min-width: 220px;
        margin-right: 14px;
        padding: 14px 16px 16px;
        background-color: #F5F9FD;
        border: 1px solid #E3EEF9;
        border-radius: 4px;
        &:last-child{
          margin-right: 0;
        }
        .bc_label{
          display: block;
          margin-bottom: 6px;
          font-size: 13px;
          color: #606266;
        }
        .bc_num{
          font-size: 24px;
          font-weight: bold;
          color: #2789e2;
          line-height: 30px;
          .bc_unit{
            margin-left: 4px;
            font-size: 12px;
            font-style: normal;
            font-weight: normal;
            color: #909399;
          }
        }
        .bc_sub{
          display: block;
          margin-bottom: 8px;
          font-size: 12px;
          color: #909399;
        }
      }
    }
    .kczy{
      width: 100%;
      max-width: 760px;
      border-spacing: 0;/*把单元格间隙设置为0*/
      border-collapse: collapse;/*设置单元格的边框合并为1*/
      td{
        border: 1px solid #DEDEDE;
        text-align: center;
        line-height: 40px;
        font-size: 13px;
        color: #606266;
        &:first-child{
          background-color: #F5F9FD;
          color: #303133;
          font-weight: bold;
        }
        &:last-child{
          color: #303133;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/Statistics.vue